import { render, staticRenderFns } from "./Print126Project3.vue?vue&type=template&id=4b81ffd8&scoped=true&"
import script from "./Print126Project3.vue?vue&type=script&lang=js&"
export * from "./Print126Project3.vue?vue&type=script&lang=js&"
import style0 from "./Print126Project3.vue?vue&type=style&index=0&id=4b81ffd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81ffd8",
  null
  
)

export default component.exports